export const inputModalForm = {
  form: 'input-modal-form',
};
